import { BlackJackBetMoveEffect } from './../component/bj_bet_move_effect';
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import BlackJackUtility from '../../Utility/blackJack_utility';
import BlackJackTableSeatView from './blackjack_table_seat_view';
import PokerTablePokerBase from '../../../table/module/poker_table/poker_table_poker_base';
const {ccclass, property} = cc._decorator;
@ccclass
export default class BlackJackTableTest  extends ViewBase{

    @property(cc.Sprite)
    sp1: cc.Sprite = null;

    @property(cc.Sprite)
    sp2: cc.Sprite = null;

    @property(cc.Node)
    nodeMe: cc.Node = null;

    @property(cc.Node)
    nodeBase: cc.Node = null;

    @property(cc.Node)
    nodeBaseLeft: cc.Node = null;

    @property(cc.Node)
    nodeBaseRight: cc.Node = null;

    @property(cc.Button)
    btnA: cc.Button = null;

    @property(cc.Button)
    btnB: cc.Button = null;

    @property(cc.Button)
    btnC: cc.Button = null;

    @property(cc.Label)
    txt: cc.Label = null;

    @property(BlackJackBetMoveEffect)
    move: BlackJackBetMoveEffect = null;
//=================================================================
    @property(PokerTablePokerBase)//poker预制
    pokerPrefab: PokerTablePokerBase = null

    @property([cc.Node])
    pokerNodes: cc.Node[] = []

    @property(cc.Node)
    startNode: cc.Node = null;

    intervalID=0;
    totalTime=20
    range=0;
    codeList:number[]=[]
    posList:number[]=[0,1]
    start () {
        
        // let a:number=123.00
        // a=Math.round(a * 100) / 100
        // this.txt.string=BlackJackUtility.addThousands(a)
        // this.btnA.node.on('click', this.onButtonA, this);
        
        // // let txt=this.btnA.node.getChildByName("Label").getComponent(cc.Label)
        // // txt.string="我是长沙人\n我叫张超"
        // // //this.btnB.node.on('click', this.onButtonB, this);
        // // //this.btnC.node.on('click', this.onButtonC, this);

        // // this.btnA.enabled=false;
        // // //this.gotoRepaly()
        // // //this.abc()
        // // //this.kk()
        // // for(let i=3;i<52;i++)
        // // {
        // //     this.codeList.push(i)
        // // }
        let a=7
        let b=6
        let arr:number[]=[1,2,3,4,5,6]
        cc.log(arr.indexOf(a))
        cc.log(arr.indexOf(b))
    }
    gotoRepaly() {
    
        let maxCount=0
        BlackJackUtility.schedule(this.node,()=>{
            //TexasSound.playBet();
            
            
            if (maxCount == 10) {
                
                this.node.stopAllActions();
            }else{
                this.onButtonA()
                
                maxCount++;
            }
        },0.1);
    }
    

    onButtonA(func?:Function)
    {

        this.schedule(()=>{
            cc.log("aaaaa")
          },0.1,0,1.5);
        // let maxCount=0
        // let pos:cc.Vec2
        // let poker:PokerTablePokerBase=null
        
        // let betViewMove=function()
        // {
        //     if (maxCount == this.posList.length) 
        //     {
        //         this.unschedule(betViewMove);
                
        //     }
        //     else
        //     {
        //         pos=BlackJackUtility.getConvertToNodeSpaceAR(this.startNode,this.pokerNodes[maxCount])
        //         poker=BlackJackUtility.makePoker(this.pokerPrefab.node,this.codeList[maxCount],this.startNode,maxCount)
        //         poker.node.angle=25
        //         poker.showBack(true)
        //         BlackJackUtility.moveToAction(poker.node,pos,0.3,BlackJackUtility.playCardTurnAnim,poker)
        //         maxCount++;
        //     }
        // }
        // this.schedule(betViewMove,0.05);





        // let index=0
        
    }
    // onButtonA() 
    // {
    //     this.move.purposeNode=this.nodeBase
    //     this.move.showBet(300)
        
       
    // }
    // onButtonB() 
    // {
    //     let leaveCallFunc = ()=>{
            
            
           
    //     }
    //     this.move.purposeNode=this.nodeBase
    //     this.move.recycleAllBet()
    //     this.move.purposeNode=this.nodeBaseLeft
    //     this.move.showBet(300)
    //     this.move.startNode=this.nodeMe
    //     this.move.purposeNode=this.nodeBaseRight
    //     this.move.checkBet(300)
    //     //this.move.obtainBet(this.nodeBase,this.nodeBaseLeft,300,leaveCallFunc)
    // }
    // onButtonC() 
    // {
    //     if(this.range%2==0)
    //     {
    //         this.move.purposeNode=this.nodeBaseLeft
    //         this.move.guiChi(this.nodeMe)
    //     }
    //     else
    //     {
    //         this.move.purposeNode=this.nodeBaseRight
    //         this.move.guiChi(this.nodeMe)
    //     }
    //     this.range++
    // }
    
    // abc()
    // {

    //     this.sp.node.active = true;
    //     this.sp.fillStart = 0.2;
    //     this.sp.fillRange = this.range;
    //     this.sp.fillCenter = cc.v2(0.5,0.5);

    //     let passTime=0
    //     this.intervalID = this.doSchedule(()=>{
    //         passTime+=cc.director.getDeltaTime();
            
    //         this.range = passTime / this.totalTime;

            
    //         this.sp.fillRange = -this.range
    //         if (this.sp.fillRange <= -1) {
    //             this.cancleSlider();
    //             this.hideOpTimeState();
    //         }
    //     },0.00,cc.macro.REPEAT_FOREVER);
    // }
    // cancleSlider(){
    //     if (this.intervalID) {
    //         this.cancelSchedule(this.intervalID);
    //         cc.log('-->>>>取消计时器')
    //         this.intervalID = null;
    //     }
    // }
    // hideOpTimeState(){
        
    //     this.sp.node.active = false;
        
    // }



    kk() {
        // this.moveToAction(this.sp1.node,this.left.position,3)
        // this.moveToAction(this.sp2.node,this.right.position,3)
    }

    moveToAction(node:cc.Node,pos:cc.Vec2,time:number,comp?:Function){
        let moveTo = cc.moveTo(time,pos);
        let callFunc = cc.callFunc(()=>{if (comp) {
            cc.log("comcomcom")
            comp();
        }})
        node.runAction(cc.sequence(moveTo,callFunc));
    }


    
        
}
